import { ObjectId } from 'bson';

export default class MongoProjectCommentLike {
  _id = null;

  projectId = "";
  commentId = "";
  likerIds = [];

  constructor() {
    this._id = new ObjectId();
  }
}
